import { BaseTileRenderer } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { IWizItemRenderer } from '@wizeoo/akm-component-lib';
import { IncExcMainObj } from '@wizeoo/akm-common-lib';
import { INC_EXC_KIND } from '@wizeoo/akm-common-lib';

/**
 * rendu d'un élément main Include / exclude
 */
@Component({
  selector: 'incex-tile-renderer',
  templateUrl: './incex-tile.renderer.html',
})
export class IncExcTileRenderer implements IWizItemRenderer<null, IncExcMainObj> {
  @ViewChild('tileRenderer', { read: BaseTileRenderer, static: true })
  tileRenderer: BaseTileRenderer;

  constructor(public elementRef: ElementRef) {}

  // Le VO manipulé
  private _data: IncExcMainObj;
  public get data(): IncExcMainObj {
    return this._data;
  }
  public set data(data: IncExcMainObj) {
    this._data = data;
    this.tileRenderer.data = data.source;
  }

  public isFD(): boolean {
    return !!this.data && this.data.kind === INC_EXC_KIND.FD;
  }

  public isChron(): boolean {
    return !!this.data && this.data.kind === INC_EXC_KIND.CHRO;
  }
}
